function pw_post_product_modal_save(personalisationID, thumbURL){
  addPwAddToCart();
}

function addPwAddToCart(){
	
  $(".pwAddToCart").show();
  
}

// Printzware helper functions
(function($){
  var $ = jQuery = $;
    // DOM Document loaded
    $(document).ready(function() {
        // On product variation select
        $(document).on('change', '.single-option-selector', function() {
            if ($(document).find('.pwAddToCart').length > 0) {

              // Reset the Printzware id input
              $(document).find('#pw_personalisation_id').val('');

              // Find the Printzware "Personalize" button
              var pwCartButton = $(document).find("#pw_cart_button");
              if (pwCartButton && pwCartButton.length > 0) {
                  // Check if this button is changed (There is a personalized product)
                  if (pwCartButton.text().includes('Edit')) {
                    // Get the original product images
                    var productImgs = $('.slides li img, .product-image-main img');
                    productImgs.each(function() {
                        var productImg = $(this);

                        // Reset the original image
                        var originalSrc = productImg.attr("data-src");
                        productImg.attr('src', originalSrc);
                        productImg.attr('srcset', originalSrc);
                    });

                    // Change the name of the Printzware button
                    pwCartButton.text('Create');
                  }
              }
            }
        });
      $(document).find('div[data-gallery="product-5639081492635-gallery"]').remove();
      
      setInterval(function() {
      var a = 0;
      $(document).find('.pwEditOrderLink').each(function() {
        if (a) {
        	$(this).remove();
        }
        a = a+1;
      })
      
      }, 1000);
      
    });
  
})(jQuery);

// Show the add to cart button
function checkInput() {
  var persId = document.getElementById('pw_personalisation_id');
  if (persId && typeof persId == 'object') {
    var val = persId.value;
    if (val && val.length > 0) {
      document.getElementById('pw_cart_button').value = 'Edit';
      var addToCartBtn = document.querySelector('.add_to_cart');
      if (addToCartBtn && typeof addToCartBtn == 'object') {
      	addToCartBtn.removeAttribute('disabled');
      }
      clearInterval(checkInput);
    }
  }
}
document.addEventListener('DOMContentLoaded', function() {
  var pwCartButton = document.getElementById('pw_cart_button');
  if (pwCartButton && typeof pwCartButton == 'object') {
    pwCartButton.addEventListener('click', function() {	
      setInterval(checkInput, 1000);
    });
  }
});


/* Faq's toggle js*/
  
  jQuery(document).ready(function() {
  //toggle the component with class accordion_body
  jQuery(".accordion_body").hide();
  jQuery(".accordion_head").click(function() {
    jQuery(".accordion_head").not(this).removeClass('open');
    if (jQuery('.accordion_body').is(':visible')) {
      jQuery(".accordion_body").slideUp(300);
      jQuery(this).removeClass('open');
    }
    if (jQuery(this).next(".accordion_body").is(':visible')) {
      jQuery(this).next(".accordion_body").slideUp(300);
      jQuery(this).removeClass('open');
    } else {
      jQuery(this).next(".accordion_body").slideDown(300);
      jQuery(this).addClass('open');
    }
  });
    
    if(jQuery('#default-open').length){ 
   		jQuery('#default-open').click();
    }
});